import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { ModalShell } from '../ui/shell';
import { Btn } from '../ui/primitives';
import CourseSettingForm from './CourseSettingForm';

/**
 * Per-row course settings modal — wraps the shared settings form without duplicating logic.
 */
const CourseSettingDialog = ({
  open,
  courseDetails,
  onClose,
  onSaved,
  saveLocked = false,
  onSaveBlocked,
}) => {
  const [actionState, setActionState] = useState({ isLoading: false });

  if (!open || !courseDetails) return null;

  const courseName = courseDetails.courseName || 'Course';
  const formId = 'course-settings-form';

  const handleSaveClick = (event) => {
    if (!saveLocked) return;
    event.preventDefault();
    if (onSaveBlocked) onSaveBlocked();
  };

  return (
    <ModalShell
      title="Course settings"
      sub={courseName}
      onClose={onClose}
      max="680px"
      foot={(
        <>
          <Btn type="button" $variant="ghost" onClick={onClose} disabled={actionState.isLoading}>
            Cancel
          </Btn>
          <Btn
            type={saveLocked ? 'button' : 'submit'}
            form={saveLocked ? undefined : formId}
            $variant={saveLocked ? 'ghost' : 'subtle'}
            disabled={actionState.isLoading}
            onClick={handleSaveClick}
          >
            {saveLocked ? <Lock size={15} strokeWidth={2} aria-hidden="true" /> : null}
            {actionState.isLoading ? 'Saving…' : 'Save changes'}
          </Btn>
        </>
      )}
    >
      <CourseSettingForm
        key={courseDetails.courseId}
        courseDetails={courseDetails}
        onDismiss={onClose}
        onSaved={onSaved}
        formId={formId}
        onActionStateChange={setActionState}
        showInlineFooter={false}
        saveDisabled={saveLocked}
      />
    </ModalShell>
  );
};

export default CourseSettingDialog;
